export default {
    contractEditor: {
        backToDashboard: 'Back to dashboard',
        editContract: 'Edit contract',
        deliveryLine: 'Delivery: {start} → {end} · Total: {total} · €{price}/MW',
        ref: 'Ref: {value}',
        traded: 'Traded: {value}',
        unit: 'Unit: {value}',
        attachments: '{count} attachment | {count} attachments',
        saveRejected: 'Save rejected',
        tabsAria: 'Contract editor tabs',
        tabBins: 'Bins',
        tabAudit: 'Audit',
        runningTotals: 'Total (sum of bins): {total} across {days} days · {dirty} dirty',
        discard: 'Discard',
        confirmSave: 'Confirm & Save',
        discardTitle: 'Discard unsaved edits?',
        discardBody: '{count} day(s) have unsaved edits. Discarding loses them.',
    },
}
